const mEditionBillingMyPaymentsInvoice = {
  mEditionBillingMyPaymentsInvoice: {
    alerts: {
      download: {
        error: 'No hay pagos para exportar',
        success: 'Downloaded...'
      }
    }
  }
}

export default mEditionBillingMyPaymentsInvoice
